import _getSymbolByCurrencyCode from 'currency-symbol-map'

// Helper functions to format input numeric values to currency.

// Receives a numeric value and transforms it to currency format.

// Transforms string into number.
export const toNumber = value => {
  if (!value) return ''

  return Number(onlyNumbers(value))
}

// Removes all dots and commas off of the number.
export function onlyNumbers(input) {
  return toStr(input).replace(/\D+/g, '') || ''
}

// Transforms the given value into a string.
export function toStr(value) {
  return value ? value.toString() : ''
}

// Concat the thousands and decimal with the separator character.
export function joinIntegerAndDecimal(integer, decimal, separator) {
  return decimal ? integer + separator + decimal : integer
}

// Parses the string to number.
export function removeSeparatorsAndParseToNumber(numberAsString) {
  return parseFloat(numberAsString.replace(/[.,\s]/g, ''))
}

export function getSymbolByCurrencyCode(currencyCode) {
  return _getSymbolByCurrencyCode(currencyCode)
}

export function format(value, options = {}) {
  if (typeof value !== 'number') return value

  const _options = {
    locale: undefined,
    currency: undefined,
    commarize: false,
    precision: 2,
    ...options
  }

  if (!_options.commarize && _options.currency) {
    return new Intl.NumberFormat(_options.locale, {
      style: 'currency',
      currency: _options.currency,
      minimumFractionDigits: _options.precision,
      maximumFractionDigits: _options.precision
    }).format(value)
  } else if (!_options.commarize && !_options.currency) {
    return new Intl.NumberFormat(_options.locale, { minimumFractionDigits: _options.precision, maximumFractionDigits: _options.precision }).format(value)
  } else if (_options.commarize && _options.currency === null) {
    return commarize(value)
  } else if (_options.commarize && _options.currency !== null) {
    const commarizedValue = commarize(value)
    const symbol = getSymbolByCurrencyCode(_options.currency)

    if (commarizedValue.startsWith('-')) {
      return `-${symbol}${commarizedValue.slice(1)}`
    } else {
      return `${symbol}${commarizedValue}`
    }
  }

  return value
}

function commarize(value, precision = 2) {
  const absValue = Math.abs(value)
  if (absValue >= 1000) {
    const units = ['K', 'M', 'B', 'T']
    const sign = value < 0 ? '-' : ''
    const precisionCorrection = Math.pow(10, precision)
    const unit = Math.floor((absValue.toFixed(0).length - 1) / 3) * 3
    const num = Math.floor((absValue / Math.pow(10, unit)) * precisionCorrection) / precisionCorrection
    const unitName = units[Math.floor(unit / 3) - 1]
    return sign + num + unitName
  }
  return value.toString()
}
